import React, { Component } from "react";
import createGraph from "ngraph.graph";
import Swal from "sweetalert2";
import path from "ngraph.path";
import "./App.css";
import "react-select/dist/react-select.css";
import Select from "react-select";
import generalConfig from "./mp-config.json"

import {
  transformMatrix,
  distance,
  makeId,
  closestDot,
  collides
} from "./utils/calc";
import {
  drawLink,
  paintDot,
  drawRoute,
  paintCircle,
} from "./utils/canvasPainter";
import { saveRoute } from "./utils/saveManager";
import { loadStores } from "./service/service";

const MODE_DRAWING_NODES = "drawing_nodes";
const MODE_FIND_ROUTE = "find_route";
const MODE_LINK_ROUTES = "link_routes";
const MODE_DRAW_STORE = "draw_store";
const MODE_DRAW_ACCESS = "set_access";
const MODE_DRAW_SERVICE = "set_service";
const MODE_INFO = "info";
const MODE_CONFIG = "config";
const CONNECT_FLOORS = "connect_floors";

var canvas;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: false,
      end: false,
      // bw: 1832,
      // bh: 1670,
      bw: 1522,
      bh: 669,
      p: 1,
      w: 1,
      h: 1,
      grid: [],
      canvas: false,
      context: false,
      graph: false,
      mode: MODE_CONFIG,
      markedSteps: [],
      linkStart: false,
      linkEnd: false,
      deg: 16 * Math.PI / 180,
      stores: false,
      currentFloor: "f3",
      editingNode: false,
      floors: {},
      showModal: false,
      selectedNode: null,
      selectedFloor: null,
      selectedConnections: {},
    };
    this.onMapSet = this.onMapSet.bind(this);
  }

  componentDidMount() {
    let { bw, bh } = this.state;
    canvas = document.createElement("canvas");
    var bdy = document.getElementById("app");
    bdy.appendChild(canvas);
    canvas.width = bw;
    canvas.height = bh;
    var context = canvas.getContext("2d");
    this.setState(
      {
        canvas,
        context
      },
      () => this.setMainGrid()
    );
    //this.processStores();
  }

  componentWillMount() {
    this.onKeyPress = this.onKeyPress.bind(this);
    document.addEventListener("keydown", this.onKeyPress, false);
  }

  setMainGrid() {
    let { context, canvas, bw, bh, p, w, h } = this.state;
    var ctx = this;
    var rot = -this.state.deg;
    context.rotate(rot);
    context.fillStyle = "blue";
    var grid = [];
    for (var x = -1000; x <= bw * 1.5; x += p) {
      for (var y = 0; y <= bh * 1.5; y += p) {
        grid.push({ x: x, y: y, w: w, h: h });
        //context.fillRect(x, y, 1, 1);
      }
    }
    grid = transformMatrix(grid, -rot);
    canvas.addEventListener("click", e => {
      var rect = collides(grid, e.offsetX, e.offsetY);
      if (rect) {
        if (ctx.state.mode === MODE_FIND_ROUTE) ctx.setStartOrEnd(rect);
        if (ctx.state.mode === MODE_DRAWING_NODES) ctx.setNode(rect);
        if (ctx.state.mode === MODE_LINK_ROUTES) ctx.setLink(rect);
        if (ctx.state.mode === MODE_DRAW_STORE) ctx.setStore(rect);
        if (ctx.state.mode === MODE_DRAW_ACCESS) ctx.setAccess(rect);
        if (ctx.state.mode === MODE_DRAW_SERVICE) ctx.setService(rect);
        if (ctx.state.mode === MODE_INFO) ctx.displayNodeInfo(rect);
        // if (ctx.state.mode === CONNECT_FLOORS) ctx.setLink(rect);
      }
    });
    let graph = createGraph();
    this.setState(
      {
        grid,
        graph
      }
      //,() => this.drawLoadedData(p3)
    );
  }

  displayNodeInfo(rect) {
    let { markedSteps, context } = this.state;
    let dot = closestDot(rect, markedSteps);
    if (dot) {
      this.setState({ editingNode: dot });
      this.drawLoadedData(markedSteps)
      paintCircle(context, rect, 4, "red");
    }
  }

  setNode(rect, setting = true) {
    let { graph, context, markedSteps } = this.state;
    let id = "";
    if (setting) {
      id = makeId();
      rect.id = id;
      /*
      let dot = closestDot(rect, markedSteps);
      if (dot) {
        context.fillStyle = "black";
        context.fillRect(dot.x, dot.y, 2, 2);
        graph.removeNode(dot.id);
        graph.forEachLinkedNode(dot.id, (linkedNode, link) => {
          graph.removeLink(link);
        });
        let markedSteps = this.state.markedSteps.filter(s => s.id !== dot.id);
        this.setState({ graph, markedSteps });
        return;
      }*/
      paintDot(context, rect, "magenta");
    } else id = rect.id;
    graph.addNode(id, rect);
    this.setState({
      markedSteps: [rect, ...markedSteps],
      graph
    });
  }

  setStore(rect) {
    let { allStores } = this.state;
    if (!allStores) {
      alert("Tiendas no cargadas");
      return;
    }
    var options = {};
    allStores.forEach(s => {
      options[s.id.toString()] = s.title;
    });
    Swal({
      text: "¿A cuál tienda corresponde este punto?",
      type: "warning",
      showCancelButton: true,
      input: "select",
      inputOptions: options,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        let { markedSteps, graph, context } = this.state;
        var store = allStores.filter(
          s => s.id === result.value
        )[0];
        if (
          markedSteps.filter(
            s => s.store_info && s.store_info.id === result.value
          )[0]
        ) {
          //Ya se había marcado
          alert("Tienda ya marcada");
          return;
        }
        console.log("El store", store, result, allStores, rect)
        // var id = makeId(); // This is for when the store does not have an ID
        rect.id = store.id;
        rect.store = true;
        rect.store_info = store;
        graph.addNode(store.id, rect);
        paintCircle(context, rect);
        this.setState({
          markedSteps: [rect, ...this.state.markedSteps],
          graph
        });
      }
    });
  }

  setAccess(rect) {
    Swal({
      text: "Ingresa una descripción",
      showCancelButton: true,
      input: "text",
      inputPlaceholder: "ej. Escalera mecánica",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        let { graph } = this.state;
        var id = makeId();
        rect.id = id;
        rect.access = true;
        rect.access_description = result.value;
        graph.addNode(id, rect);
        paintCircle(this.state.context, rect, 8, "pink");
        this.setState({
          markedSteps: [rect, ...this.state.markedSteps],
          graph
        });
      }
    });
  }

  setService(rect) {
    Swal({
      text: "Ingresa una descripción",
      showCancelButton: true,
      input: "text",
      inputPlaceholder: "ej. Baño y Redbanc",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        let { context, graph, markedSteps } = this.state;
        var id = makeId();
        rect.id = id;
        rect.service = true;
        rect.service_description = result.value;
        graph.addNode(id, rect);
        paintCircle(context, rect, 8, "green");
        this.setState({
          markedSteps: [rect, ...markedSteps],
          graph
        });
      }
    });
  }

  setLink(rect) {
    let { markedSteps, linkStart, context } = this.state;
    let dot = closestDot(rect, markedSteps);
    if (dot) {
      dot = Object.assign({}, dot);
      if (!linkStart) {
        this.setState({ linkStart: dot });
        paintDot(context, dot, "green");
      } else if (linkStart) {
        let { linkStart, graph } = this.state;
        var w = distance(linkStart, dot);
        if(w === 0) return // Evitamos links conmigo mismo
        paintDot(context, dot, "red");
        drawLink(linkStart, dot, context);
        graph.addLink(linkStart.id, dot.id, {
          weight: w
        });
        var linkTo = { from: linkStart.id, to: dot.id, weight: w };
        var linkFrom = { to: linkStart.id, from: dot.id, weight: w };
        if (dot.links) dot.links = [linkTo, linkFrom, ...dot.links];
        else dot.links = [linkTo, linkFrom];
        this.setState({
          linkStart: false,
          graph,
          markedSteps: [dot, ...markedSteps.filter(s => s.id !== dot.id)]
        });
        this.resetMarkedSteps();
      }
    }
  }

  setStartOrEnd(rect) {
    let dot = closestDot(rect, this.state.markedSteps);
    if (dot)
      if (!this.state.start) {
        this.setState({ start: dot });
        paintDot(this.state.context, dot, "yellow");
      } else if (!this.state.end) {
        this.findRoute(this.state.start, dot);
        this.setState({ start: false });
        this.resetMarkedSteps();
      }
  }

  processStores(url) {
    loadStores((success, response) => {
      if (success) {
        var stores = response.tiendas;
        if (stores.length > 0) {
          var f1 = [],
            f2 = [],
            f3 = [],
            f4 = [],
            f0 = [],
            fm1 = [];
          stores.forEach(s => {
            switch (s.nivel.trim()) {
              case "-1":
                fm1.push(s);
                break;
              case "0":
                f0.push(s);
                break;
              case "1":
                f1.push(s);
                break;
              case "2":
                f2.push(s);
                break;
              case "3":
                f3.push(s);
                break;
              case "4":
                f4.push(s);
                break;
              default:
                //console.log(s);
                break;
            }
          });
          var stateStores = {
            f0: f0.sort((a, b) => a.title > b.title),
            f1: f1.sort((a, b) => a.title > b.title),
            f2: f2.sort((a, b) => a.title > b.title),
            f3: f3.sort((a, b) => a.title > b.title),
            f4: f4.sort((a, b) => a.title > b.title),
            fm1: fm1.sort((a, b) => a.title > b.title)
          };
          this.setState({
            stores: stateStores,
            allStores: [...f0, ...f1, ...f2, ...f3, ...f4, ...fm1]
          });
        }
      } else {
        alert("Ocurrió un error obteniendo las tiendas");
      }
    }, url);
  }

  resetMarkedSteps() {
    /*this.state.markedSteps.map(d => {
      return paintDot(
        this.state.context,
        d,
        DEFAULT_DOT_COLOR,
        DEFAULT_DOT_SIZE
      );
    });*/
  }

  findRoute(start, end) {
    let { graph, context } = this.state;
    let pathFinder = path.aStar(graph);
    let result = pathFinder.find(start.id, end.id);
    drawRoute(result.map(r => r.data), context);
  }

  loadRoute() {
    //this.refs.fileUploader.click();
    var input = document.getElementById("fileinput");
    input.click();
    var ctx = this;
    input.onchange = function() {
      if (input.files[0]) {
        var fr = new FileReader();
        fr.onload = function(e) {
          var res = e.target.result;
          var dots = JSON.parse(res);
          ctx.drawLoadedData(dots);
        };
        fr.readAsText(input.files[0]);
      }
    };
  }

  loadFloors() {
    this.refs.fileUploader.click();
    const input = document.getElementById("fileinput2");
    const points = {};
    const fileReadPromises = []; // Array to track file read promises
  
    input.onchange = () => {
      // Read files
      for (let i = 0; i < input.files.length; i++) {
        if (input.files[i]) {
          const fr = new FileReader();
          const fileName = input.files[i].name;
  
          // Create a promise for each file read
          const fileReadPromise = new Promise((resolve) => {
            fr.onload = (e) => {
              const res = e.target.result;
              const dots = JSON.parse(res);
              points[fileName] = dots; // Add the parsed data to the points object
              resolve(); // Resolve the promise when the file is processed
            };
          });
  
          fileReadPromises.push(fileReadPromise); // Add the promise to the array
          fr.readAsText(input.files[i]);
        }
      }
  
      // Wait for all file reads to complete
      Promise.all(fileReadPromises).then(() => {
        // Update the state with the loaded floors
        this.setState({ floors: points }, () => {
          console.log("Points", points);
        });
      });
    };
  }

  handleNodeConnectionChange(floorName, nodeId, value) {
    console.log("Floor", floorName, "Node", nodeId, "Value", value);
  };

  renderConnectFloors(floors) {
    const floorKeys = Object.keys(floors); // Get all floor names
  
    return (
      <div>
        {floorKeys.map((floorName) => {
          const nodes = floors[floorName].filter((node) => node.access); // Filter nodes with `access` property
  
          return (
            <div key={floorName} style={{ marginBottom: "20px" }}>
              <h4>{`Floor: ${floorName}`}</h4>
              <ul>
                {nodes.map((node) => (
                  <li
                    key={node.id}
                    style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                    onClick={() => this.openModal(floorName, node)}
                  >
                    {`Node ID: ${node.id} (${node.access_description || "No description"})`}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
        <button
          onClick={() => this.downloadFiles(floors)}
          className="btn btn-primary"
          style={{ marginTop: "20px" }}
        >
          Save Connections
        </button>
      </div>
    );
  }

  handleCheckboxChange(floorName, nodeId, isChecked) {
    this.setState((prevState) => {
      const updatedConnections = { ...prevState.selectedConnections };
  
      if (isChecked) {
        if (!updatedConnections[floorName]) {
          updatedConnections[floorName] = [];
        }
        updatedConnections[floorName].push(nodeId);
      } else {
        updatedConnections[floorName] = updatedConnections[floorName].filter((id) => id !== nodeId);
        if (updatedConnections[floorName].length === 0) {
          delete updatedConnections[floorName];
        }
      }
  
      return { selectedConnections: updatedConnections };
    });
  }

  renderModal() {
    const { showModal, selectedNode, selectedFloor, floors, selectedConnections } = this.state;
    if (!showModal || !selectedNode || !selectedFloor) return null;
    const floorKeys = Object.keys(floors).filter((floor) => floor !== selectedFloor); // Exclude the current floor
  
    return (
      <div className="modall" style={{ maxHeight: "50vh", backgroundColor: "#aaaaaa", padding: "20px" }}>
        <div className="modal-content">
          <h4>{`Connect Node: ${selectedNode.id}`}</h4>
          {floorKeys.map((floorName) => {
            const nodes = floors[floorName].filter((node) => node.access); // Filter nodes with `access` property
  
            return (
              <div key={floorName} style={{ marginBottom: "20px" }}>
                <h5>{`Floor: ${floorName}`}</h5>
                <ul>
                  {nodes.map((node) => (
                    <li key={node.id}>
                      <label>
                        <input
                          type="checkbox"
                          checked={(selectedConnections[floorName] || []).includes(node.id)} // Fix applied here
                          onChange={(e) => this.handleCheckboxChange(floorName, node.id, e.target.checked)}
                        />
                        {`Node ID: ${node.id} (${node.access_description || "No description"})`}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
          <button onClick={() => this.saveConnections()}>Save</button>
          <button onClick={() => this.closeModal()}>Cancel</button>
        </div>
      </div>
    );
  }

  downloadFiles(floors) {
    const updatedFloors = {};
  
    // Iterate through each floor and update nodes with access_info
    Object.keys(floors).forEach((floorName) => {
      updatedFloors[floorName] = floors[floorName].map((node) => {
        if (node.access) {
          // Add or update the access_info property
          const newPairs= {}
          Object.keys(node.access_info.pairs).forEach((link) => {
            const name = link.replace(".json", "");
            // const floor = name.split("-")[1];
            // Instead of using split, fin the first dash and use the rest of the string
            const floor = name.substring(name.indexOf("-") + 1);
            newPairs[floor] = node.access_info.pairs[link][0];
          });
          return {
            ...node,
            access_info: {
              floor: floorName.substring(floorName.indexOf("-") + 1).replace(".json", ""),
              pairs: newPairs || {}, // Use selected connections
            },
          };
        }
        return node; // Return the node as is if it doesn't have access
      });
    });
  
    // Download the updated floors as JSON files
    Object.keys(updatedFloors).forEach((floorName) => {
      const blob = new Blob([JSON.stringify(updatedFloors[floorName], null, 2)], {
        type: "application/json",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${floorName}.json`; // Use the floor name as the file name
      a.click();
      URL.revokeObjectURL(url);
    });
  
    alert("Connections saved and files downloaded!");
  }

  saveConnections() {
    const { selectedNode, selectedConnections, floors, selectedFloor } = this.state;
  
    // Update the `pairs` property of the selected node
    const updatedNode = {
      ...selectedNode,
      access_info: {
        ...selectedNode.access_info,
        pairs: selectedConnections,
      },
    };
  
    // Update the floors state with the updated node
    const updatedFloors = {
      ...floors,
      [selectedFloor]: floors[selectedFloor].map((node) =>
        node.id === updatedNode.id ? updatedNode : node
      ),
    };
  
    this.setState(
      {
        floors: updatedFloors,
        showModal: false,
        selectedNode: null,
        selectedFloor: null,
        selectedConnections: {},
      },
      () => {
        console.log("Updated Floors:", this.state.floors);
      }
    );
  }

  openModal(floorName, node) {
    !node.access_info ? node.access_info = {} : null;
    this.setState({
      showModal: true,
      selectedNode: node,
      selectedFloor: floorName,
      selectedConnections: node.access_info.pairs || {}, // Load existing connections if available
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      selectedNode: null,
      selectedFloor: null,
      selectedConnections: {},
    });
  }

  drawLoadedData(dots) {
    let { context, bw, bh } = this.state;
    var graph = createGraph();
    context.save();
    context.clearRect(0, 0, bw * 1.5, bh * 1.5);
    
    var markedStepsAux = [];
    dots.forEach(d => {
      markedStepsAux = [d, ...markedStepsAux];
      if (d.store) paintCircle(context, d);
      else if (d.access) paintCircle(context, d, 4, "magenta");
      else if (d.service) paintCircle(context, d, 4, "green");
      else paintCircle(context, d, 3, "pink")
      this.setNode(d, false);
      if (d.links)
        d.links.forEach(l => {
          let fromDot = dots.filter(d => d.id === l.from)[0];
          let end = dots.filter(d => d.id === l.to)[0];
          drawLink(fromDot, end, context);
          graph.addLink(fromDot.id, end.id, { weight: distance(fromDot, end) });
        });
      graph.addNode(d.id, d);
    });
    this.setState({ graph, markedSteps: markedStepsAux });
  }

  changeConfig(){
    this.setState({
      mode: MODE_CONFIG
    })
  }

  onMapSet(e, name, floor){
    canvas.style.background = `url(${e.target.value})`;
    canvas.style.backgroundRepeat = 'no-repeat';
    canvas.style.backgroundSize = 'contain';
    canvas.style.backgroundPosition = 'center';
    let auxConf;
    generalConfig.forEach(function(c){
      c.floors.forEach(function(f){
        if(f.url === e.target.value)
          auxConf = c;
      });
    });
    this.setState({ piso: { floor, name } });
    const tempUrl = auxConf.stores_url.includes("REACT_APP_STORES") ? process.env.REACT_APP_STORES.trim() : auxConf.stores_url;
    this.processStores(tempUrl)
  }

  onModeChange(mode) {
    this.resetMarkedSteps();
    this.setState({ mode });
  }

  onKeyPress(event) {
    let { mode } = this.state;
    switch (event.keyCode) {
      case 37: // flecha izquierda
        if (mode !== MODE_INFO) return;
        this.onKeyPressStep(event, "editingNodeX", false);
        break;
      case 38: // flecha arriba
        if (mode !== MODE_INFO) return;
        this.onKeyPressStep(event, "editingNodeY", false);
        break;
      case 39: // flecha derecha
        if (mode !== MODE_INFO) return;
        this.onKeyPressStep(event, "editingNodeX", true);
        break;
      case 40: // flecha abajo
        if (mode !== MODE_INFO) return;
        this.onKeyPressStep(event, "editingNodeY", true);
        break;
      case 48:
        this.onModeChange(MODE_INFO);
        break;
      case 49:
        this.onModeChange(MODE_DRAWING_NODES);
        break;
      case 50:
        this.onModeChange(MODE_DRAW_STORE);
        break;
      case 51:
        this.onModeChange(MODE_DRAW_ACCESS);
        break;
      case 52:
        this.onModeChange(MODE_DRAW_SERVICE);
        break;
      case 53:
        this.onModeChange(MODE_LINK_ROUTES);
        break;
      case 54:
        saveRoute(this.state)
        break;
      case 55:
        this.loadRoute();
        break;
      case 56:
        this.changeConfig();
        break;
      case 8: // delete
        //this.onEditingNodeDelete();
        break;
      default:
        break;
    }
  }

  onKeyPressStep(e, elementId, up) {
    const changeEvent = new Event("input", { bubbles: true });
    var element = document.getElementById(elementId);
    if (up) element.stepUp(1);
    else element.stepDown(1);
    e.preventDefault();
    element.dispatchEvent(changeEvent);
  }

  onEditingNodeChanged(e, node, val) {
    let { markedSteps } = this.state;
    var auxNode = Object.assign({}, node);
    auxNode.modified = true;
    auxNode[val] = e.target.value;
    var markedStepsAux = [
      auxNode,
      ...markedSteps.filter(s => s.id !== auxNode.id)
    ];
    this.setState({ editingNode: auxNode, markedSteps: markedStepsAux }, () =>
      this.drawLoadedData(markedStepsAux)
    );
  }

  onEditingNodeDelete(node) {
    let { markedSteps, graph } = this.state;
    var markedStepsAux = Object.assign([], markedSteps);
    if (!node) node = this.state.editingNode;
    markedStepsAux = markedStepsAux.filter(s => s.id !== node.id);
    markedStepsAux.forEach(n => {
      if(n.links)
        n.links = n.links.filter(l => l.to !== node.id && l.from !== node.id);
      else n.links = [];
    });
    graph.removeNode(node.id);
    graph.forEachLinkedNode(node.id, (linkedNode, link) => {
      graph.removeLink(link);
    });
    this.setState({ editingNode: false, markedSteps: markedStepsAux }, () =>
      this.drawLoadedData(markedStepsAux)
    );
  }

  onEditingNodeDeleteLinks(node){
    let { markedSteps, graph } = this.state;
    var auxNode = Object.assign({}, node);
    auxNode.modified = true;
    auxNode.links = []
    var markedStepsAux = [
      auxNode,
      ...markedSteps.filter(s => s.id !== auxNode.id)
    ];
    markedSteps.forEach(n => {
      if(n.links)
        n.links = n.links.filter(l => l.to !== node.id && l.from !== node.id);
      else n.links = [];
    });
    graph.forEachLinkedNode(node.id, (linkedNode, link) => {
      graph.removeLink(link);
    });
    this.setState({ editingNode: auxNode, markedSteps: markedStepsAux }, () =>
      this.drawLoadedData(markedStepsAux)
    );
  }

  onEditingNodeChangeStore(selected) {
    if (selected) {
      let { editingNode, markedSteps, allStores } = this.state;
      let store = allStores.filter(s => s.title === selected.label)[0];
      let auxEditingNode = Object.assign({}, editingNode);
      auxEditingNode.store_info = store;
      let markedStepsAux = [
        auxEditingNode,
        ...markedSteps.filter(s => s.id !== editingNode.id)
      ];
      this.setState(
        {
          editingNode: auxEditingNode,
          markedSteps: markedStepsAux
        },
        () => this.drawLoadedData(markedStepsAux)
      );
    }
  }

  renderStoresSelector(node, onChange) {
    let { allStores, editingNode } = this.state;
    var options = allStores.map(s => {
      return {
        label: `${s.title}`,
        value: s.id
      };
    });
    return (
      <Select
        searchable={true}
        name="form-field-name"
        placeholder="Seleccionar"
        value={
          editingNode ? (
            {
              label: editingNode.store_info.title,
              value: editingNode.store_info.id
            }
          ) : (
            options[0]
          )
        }
        onChange={onChange}
        options={options}
      />
    );
  }

  renderEditNodeForm(node) {
    return (
      <form style={{ height: "100px" }}>
        <div className="form-group">
          <label>x</label>
          <input
            id="editingNodeX"
            className="form-control"
            value={node.x}
            type="number"
            step="0.4"
            onChange={e => this.onEditingNodeChanged(e, node, "x")}
          />
        </div>
        <div className="clearfix" />
        <div className="form-group">
          <label>y</label>
          <input
            id="editingNodeY"
            className="form-control"
            value={node.y}
            type="number"
            step="0.4"
            onChange={e => this.onEditingNodeChanged(e, node, "y")}
          />
        </div>
        <div className="clearfix" />
        {node.store && (
          <div className="form-group">
            <label>Tienda: </label>
            {this.renderStoresSelector(node, (selected) => this.onEditingNodeChangeStore(selected))}
          </div>
        )}
        {node.links && (
          <div className="form-group">
            <label>Nro de Links: </label>
            {node.links.length}
            <div
              onClick={() => this.onEditingNodeDeleteLinks(node)}
              className="btn btn-sm btn-danger ml-1"
            >
              Eliminar links
            </div>
          </div>
        )}
        <div className="form-group">
          <label>Id: </label>
          {node.id}
        </div>
        <div
          onClick={() => this.onEditingNodeDelete(node)}
          className="btn btn-danger ml-1"
        >
          Eliminar
        </div>
        <div className="clearfix" />
      </form>
    );
  }

  renderChangeConfig(){
    return (
      <form style={{ height: "150px" }}>
        {generalConfig.map(c => {
          return (
            <div key={`${c.id}`}>
              <h6>{c.name}</h6>
              <ul>
                {c.floors.map(f => {
                  return (
                    <div key={`${f.url}`}>
                      <input name="map" onChange={(e) => this.onMapSet(e, c.name, f.name)} type="radio" value={`${f.url}`}/>&nbsp;{f.name}
                    </div>
                  )
                })}
              </ul>
            </div>
          )
        })
        }
      </form>
    );
  }

  render() {
    let { editingNode, floors } = this.state;
    return (
      <div id="app" className="App">
        <div className="row content btns-row">
          <input
            alt="canvas"
            type="file"
            id="fileinput"
            ref="fileUploader"
            style={{ display: "none" }}
          />
          <input
            alt="canvas"
            type="file"
            id="fileinput2"
            ref="fileUploader2"
            multiple
            style={{ display: "none" }}
          />
          <div
            onClick={() => this.onModeChange(MODE_DRAWING_NODES)}
            className="btn-mp btn btn-danger"
          >
            {this.state.mode === MODE_DRAWING_NODES && (
              <i className="fa fa-check" />
            )}{" "}
            Dibujar Nodos (1)
          </div>
          <div
            onClick={() => this.onModeChange(MODE_DRAW_STORE)}
            className="btn-mp btn btn-warning"
          >
            {this.state.mode === MODE_DRAW_STORE && (
              <i className="fa fa-check" />
            )}{" "}
            Dibujar Tiendas (2)
          </div>
          <div
            onClick={() => this.onModeChange(MODE_DRAW_ACCESS)}
            className="btn-mp btn btn-primary"
          >
            {this.state.mode === MODE_DRAW_ACCESS && (
              <i className="fa fa-check" />
            )}{" "}
            Dibujar Acceso (3)
          </div>
          <div
            onClick={() => this.onModeChange(MODE_DRAW_SERVICE)}
            className="btn-mp btn btn-default"
          >
            {this.state.mode === MODE_DRAW_SERVICE && (
              <i className="fa fa-check" />
            )}{" "}
            Dibujar Servicio (4)
          </div>
          <div
            onClick={() => this.onModeChange(MODE_LINK_ROUTES)}
            className="btn-mp btn btn-success"
          >
            {this.state.mode === MODE_LINK_ROUTES && (
              <i className="fa fa-check" />
            )}{" "}
            Hacer rutas (5)
          </div>
          {/*}
          <div
            onClick={() => this.onModeChange(MODE_FIND_ROUTE)}
            className="btn-mp btn btn-primary"
          >
            {this.state.mode === MODE_FIND_ROUTE && (
              <i className="fa fa-check" />
            )}{" "}
            Encontrar Ruta
          </div>*/}
          <div
            onClick={() => saveRoute(this.state)}
            className="btn-mp btn btn-info"
          >
            <i className="fa fa-download" /> Guardar Ruta (6)
          </div>
          <div
            onClick={() => this.loadRoute()}
            className="btn-mp btn btn-warning"
          >
            <i className="fa fa-upload" /> Cargar Ruta (7)
          </div>
          <div
            onClick={() => this.changeConfig()}
            className="btn-mp btn btn-success"
          >
            {this.state.mode === MODE_CONFIG && (
              <i className="fa fa-check" />
            )}{" "}
            Config (8)
          </div>
          <div
            onClick={() => this.onModeChange(MODE_INFO)}
            className="btn-mp btn btn-default"
          >
            {this.state.mode === MODE_INFO && (
              <i className="fa fa-check" />
            )}{" "}
            Info (0)
          </div>
          <div
            onClick={() => {
              this.loadFloors();
              this.onModeChange(CONNECT_FLOORS);
            }}
            className="btn-mp btn btn-default"
          >
            {this.state.mode === CONNECT_FLOORS && (
              <i className="fa fa-check" />
            )}{" "}
            Conectar Pisos (9)
          </div>
          {/*<div onClick={() => this.findRoute()} className="btn-mp btn">
            Buscar ruta
          </div>*/}
        </div>
        {this.state.mode === CONNECT_FLOORS && this.state.floors && (
          <div className="node-info-container">
            {this.renderConnectFloors(this.state.floors)}
          </div>
        )}
        {this.state.mode === MODE_INFO &&
        editingNode && (
          <div className="node-info-container">
            {this.renderEditNodeForm(editingNode)}
          </div>
        )}
        {this.state.mode === MODE_CONFIG &&
        (
          <div className="node-info-container">
            {this.renderChangeConfig()}
          </div>
        )}
          {/* {this.renderConnectFloors(floors)} */}
        {this.renderModal()}
        {/*<img id="img" src={img} />*/}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js